import { type User, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";

import { auth } from "integrations/firebase/auth";

/**
 * The signed-in Firebase user, or null.
 *
 * `loading` is separate from `user === null` on purpose: the SDK resolves a
 * persisted session asynchronously, so treating "not yet known" as "signed out"
 * flashes the sign-in screen on every reload for a user who is signed in.
 */
export function useAuthUser(): { user: User | null; loading: boolean } {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(
    () =>
      onAuthStateChanged(auth, (next) => {
        setUser(next);
        setLoading(false);
      }),
    [],
  );

  return { user, loading };
}
